import styled from 'styled-components';

export const StandardFormWrapper = styled.form`
    display: grid;
    gap: 16px;
`;

export const StandardFormActions = styled.div`
    display: grid;
    gap: 16px;
    margin-top: 8px;
`;
